import {
    SimpleGrid,
} from '@chakra-ui/react';
import { GenericUploadQueueContext } from '../../document/components/generic-uploader/context';
import { DocumentUploadItem } from '../../document/components/generic-uploader/upload-item';

function TemporaryDocumentUploadCompliance() {
    const queue = GenericUploadQueueContext.useSelector(
        (state) => state.context.queue
    );

    return (
        <div>
            { queue.length > 0
                ? (
                    <SimpleGrid columns={2} gap={5} width="100%">
                        {queue.map((upload) => (
                            <DocumentUploadItem
                                key={upload.id}
                                actorRef={upload}
                                borderWidth={1}
                                borderColor="muted.50"
                                rounded="md"
                                px={5}
                                py={3}
                                shadow="sm"
                            />
                        ))}
                    </SimpleGrid>
                ) : (<h3> No files have been uploaded yet!</h3>)}
        </div>
    );
}

export { TemporaryDocumentUploadCompliance };
